import { render, staticRenderFns } from "./Parameter.vue?vue&type=template&id=380a2a38&scoped=true"
import script from "./Parameter.vue?vue&type=script&lang=js"
export * from "./Parameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a2a38",
  null
  
)

export default component.exports